import { Route, Navigate } from "react-router-dom";
import { PageErrorBoundaryLocal } from "@/components/PageErrorBoundaryLocal";
import { SoulBoundaryWithQuery } from "@/components/SoulBoundaryWithQuery";
import { ROUTES } from "@/constants/routes";
import { resilientLazy } from "@/lib/resilientImport";

const MeuImpacto = resilientLazy(() => import("@/pages/MeuImpacto"), "MeuImpacto");
const MinhasTurmas = resilientLazy(() => import("@/pages/MinhasTurmas"), "MinhasTurmas");
const AulasCriadas = resilientLazy(() => import("@/pages/AulasCriadas"), "AulasCriadas");
const ManageStudents = resilientLazy(() => import("@/pages/ManageStudents"), "ManageStudents");
const CreateEditClass = resilientLazy(() => import("@/pages/CreateEditClass"), "CreateEditClass");
const MinhaJornada = resilientLazy(() => import("@/pages/MinhaJornada"), "MinhaJornada");
// ManageAvailability removido — modelo cohort-only
const TeacherBio = resilientLazy(() => import("@/pages/TeacherBio"), "TeacherBio");
const ApplicationStatus = resilientLazy(() => import("@/pages/ApplicationStatus"), "ApplicationStatus");
const GoogleCalendarCallback = resilientLazy(() => import("@/pages/GoogleCalendarCallback"), "GoogleCalendarCallback");
const Mensagens = resilientLazy(() => import("@/pages/Mensagens"), "Mensagens");
const TeacherStudentCreations = resilientLazy(() => import("@/pages/TeacherStudentCreations"), "TeacherStudentCreations");
const CalendarioPage = resilientLazy(() => import("@/pages/CalendarioPage"), "CalendarioPage");
const MeusMateriais = resilientLazy(() => import("@/pages/MeusMateriais"), "MeusMateriais");

export const TeacherRoutes = () => (
  <>
    <Route 
      path={ROUTES.MY_GROUPS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gestão de turmas.">
          <MinhasTurmas />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route path="/minhas-turmas" element={
      <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gestão de turmas.">
        <MinhasTurmas />
      </PageErrorBoundaryLocal>
    } />
    {/* Dashboard principal usa SoulBoundaryWithQuery para reset real de queries */}
    <Route 
      path={ROUTES.MY_IMPACT} 
      element={
        <SoulBoundaryWithQuery 
          fallbackTitle="Oops! Tivemos um tropeço"
          fallbackMessage="Algo não saiu como esperado no seu impacto. Vamos tentar de novo?"
        >
          <MeuImpacto />
        </SoulBoundaryWithQuery>
      } 
    />
    <Route 
      path={ROUTES.TEACHER_CLASSES} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar experiências criadas.">
          <AulasCriadas />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.MANAGE_STUDENTS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar gestão de estudantes.">
          <ManageStudents />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.CREATE_CLASS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar criação de aula.">
          <CreateEditClass />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.EDIT_CLASS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar edição de aula.">
          <CreateEditClass />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.CLASS_HISTORY} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar histórico de aulas.">
          <MinhaJornada />
        </PageErrorBoundaryLocal>
      } 
    />
    {/* /gerenciar-disponibilidade redireciona para /minhas-turmas */}
    <Route 
      path={ROUTES.MANAGE_AVAILABILITY} 
      element={<Navigate to="/minhas-turmas" replace />}
    />
    <Route 
      path={ROUTES.TEACHER_BIO} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar bio do educador.">
          <TeacherBio />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.APPLICATION_STATUS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar status da aplicação.">
          <ApplicationStatus />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route path={ROUTES.GOOGLE_CALENDAR_CALLBACK} element={<GoogleCalendarCallback />} />
    <Route 
      path={ROUTES.MESSAGES} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar mensagens.">
          <Mensagens />
        </PageErrorBoundaryLocal>
      } 
    />
    
    {/* Student Creations Gallery */}
    <Route 
      path={ROUTES.TEACHER_STUDENT_CREATIONS} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar galeria de criações.">
          <TeacherStudentCreations />
        </PageErrorBoundaryLocal>
      } 
    />
    <Route 
      path={ROUTES.TEACHER_STUDENT_CREATIONS_VIEW} 
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar galeria de criações.">
          <TeacherStudentCreations />
        </PageErrorBoundaryLocal>
      } 
    />
    
    {/* Calendário dedicado */}
    <Route
      path={ROUTES.CALENDAR}
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar o calendário.">
          <CalendarioPage />
        </PageErrorBoundaryLocal>
      }
    />

    {/* Materiais Compartilhados */}
    <Route
      path={ROUTES.TEACHER_MATERIALS}
      element={
        <PageErrorBoundaryLocal fallbackMessage="Erro ao carregar materiais.">
          <MeusMateriais />
        </PageErrorBoundaryLocal>
      }
    />

    {/* Old journey routes redirect */}
    <Route path={ROUTES.JOURNEY_EDUCATOR} element={<Navigate to={ROUTES.MY_IMPACT} replace />} />
    <Route path="/historico-aulas" element={<Navigate to={ROUTES.CLASS_HISTORY} replace />} />
  </>
);
